var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-button-group"},_vm._l((_vm.config),function(ref){
var label = ref.label;
var value = ref.value;
var checked = ref.checked;
var disabled = ref.disabled;
var size = ref.size;
return _c('RadioButton',_vm._b({key:value,staticClass:"radio-button-group__item",on:{"change":_vm.handleChange}},'RadioButton',{ value: value, label: label, checked: checked, disabled: disabled, size: size, group: _vm.group },false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }